import { API_URL, PRICE_SCHEME_HEADER, Status } from '../constants';
import { fetch as openrFetch } from '../fetchWrapper/fetch';
import { readFileChunk } from './fileUtils';

interface IImportResult {
  success: boolean;
  invalidChannelIds: string[];
  duplicateChannelIds: string[];
}

interface IImportPriceSchemeFailureResponse {
  invalid_channel_ids: string[];
  duplicate_channel_ids: string[];
}

interface IImportPriceSchemeSuccessResponse {
  upload_url: string;
  instructions: { method: string; headers: Record<string, string> };
}

export const importPriceScheme = async (name: string, file: File, priceSchemeId?: string): Promise<IImportResult> => {
  const firstTwoRows = await readFileChunk(file);

  const url = `${API_URL}/pricing/schemes/import`;
  const res = await openrFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(priceSchemeId ? { [PRICE_SCHEME_HEADER]: priceSchemeId } : {}),
    },
    body: JSON.stringify({
      ...(priceSchemeId ? {} : { name: name }),
      csv_preview: firstTwoRows,
      csv_file_name: file.name,
    }),
  });
  if (res.status !== Status.SUCCESS) {
    const json: IImportPriceSchemeFailureResponse = await res.json();

    return {
      success: false,
      invalidChannelIds: json.invalid_channel_ids,
      duplicateChannelIds: json.duplicate_channel_ids,
    };
  }

  const {
    upload_url,
    instructions: { method, headers },
  }: IImportPriceSchemeSuccessResponse = await res.json();

  if (upload_url) {
    // aws upload
    const s3res = await fetch(upload_url, {
      method,
      headers,
      body: file,
    });
    if (s3res.status === Status.SUCCESS) {
      return { success: true, invalidChannelIds: [], duplicateChannelIds: [] };
    }
  }
  return { success: false, invalidChannelIds: [], duplicateChannelIds: [] };
};
